import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom"; // Import Link

const NewsletterSignup = () => {
  return (
    <section id="newsletter" className="w-full bg-white py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-minnestig-purple mb-4 text-center">
          Bli del av väntelistan
        </h2>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          {/* Vänster kolumn med formulär */}
          <div>
            <p className="text-xl text-gray-700 mb-12 max-w-xl">
              Få uppdateringar om lanseringen av MinneStig, appen som vägleder anhöriga i varje steg av demensresan, och få <b>exklusiv tillgång</b> innan produkten släpps.
            </p>
            <form 
              action="https://minnestig.us21.list-manage.com/subscribe/post?u=c596c46f29e1d14f190b95783&amp;id=e183eccd72&amp;v_id=329&amp;f_id=0006e1e6f0" 
              method="post" 
              id="mc-embedded-subscribe-form" 
              name="mc-embedded-subscribe-form" 
              className="validate"
              target="_blank"
            >
              <div className="space-y-4">
                <div>
                  <label htmlFor="mce-EMAIL" className="block text-sm font-medium text-gray-700 mb-2">
                    E-postadress <span className="text-red-500">*</span>
                  </label>
                  <Input
                    type="email"
                    name="EMAIL"
                    id="mce-EMAIL"
                    className="w-full px-6 py-4 text-base rounded-full border-gray-200"
                    required
                  />
                </div>

                <div className="space-y-3">
                  <p className="font-medium text-gray-700">Vilket av följande passar in på dig? <span className="text-red-500">*</span></p>
                  <select 
                    name="group[2697]" 
                    id="mce-group[2697]"
                    className="flex h-14 w-full rounded-full border border-input bg-[url('/icons/chevron-down.svg')] bg-[length:20px_20px] bg-no-repeat bg-[position:calc(100%-24px)_center] bg-white px-6 pr-12 text-base appearance-none focus:outline-none focus:ring-2 focus:ring-minnestig-purple"
                    required
                  >
                    <option value="" disabled selected>Välj ett alternativ</option>
                    <option value="1" id="mce-group[2697]-2697-0">Demensdrabbad</option>
                    <option value="2" id="mce-group[2697]-2697-1">Anhörig</option>
                    <option value="4" id="mce-group[2697]-2697-2">Vårdpersonal</option>
                    <option value="8" id="mce-group[2697]-2697-3">Annat/Vill inte säga</option>
                  </select>
                </div>

                <div className="border-t border-gray-200 pt-4 space-y-3">
                  <label className="flex items-center space-x-2">
                    <input type="checkbox" id="gdpr_1600" name="gdpr[1600]" className="rounded" required />
                    <span className="text-gray-700">Demenshjältar får skicka nyheter till mig via e-post. <span className="text-red-500">*</span></span>
                  </label>
                  <p className="text-sm text-gray-600">
                    Du kan när som helst avsäga Demenshjältar rätten att maila dig. För mer info om hur vi hanterar data, besök vår{' '}
                    <Link to="/integritetspolicy" className="text-minnestig-purple hover:underline">
                      integritetspolicy
                    </Link>
                    {' '}på vår hemsida.
                  </p>
                </div>

                <div className="hidden">
                  <input type="hidden" name="tags" value="2962338" />
                  <input type="text" name="b_c596c46f29e1d14f190b95783_e183eccd72" tabIndex={-1} />
                </div>

                <Button type="submit" className="w-full bg-[#002B45] hover:bg-minnestig-purple text-white px-8 py-4 rounded-full transition-colors">
                  Prenumerera
                </Button>
              </div>
            </form>
          </div>

          {/* Höger kolumn med bild */}
          <div className="relative hidden lg:flex justify-center items-center">
            <div className="relative w-1/2">
              <img
                src="/images/minnestig/mobile-checklist-preview-with-frame.png"
                alt="MinneStig app preview"
                className="w-full h-auto mix-blend-multiply"
              />
              <div className="absolute -top-6 -right-6 h-24 w-24 bg-minnestig-lavender rounded-full -z-10"></div>
              <div className="absolute -bottom-6 -left-6 h-16 w-16 bg-minnestig-peach rounded-full -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSignup;
